"use strict";

var _ = require("underscore");
var moment = require("moment");
var Reflux = require("reflux");
var getSlug = require("speakingurl");
var attachmentsAPI = require("app/util/api/attachments");
var activityAPI = require("app/util/api/activity");
var agendorAPI = require("app/util/api/agendor-api");
var S3Upload = require("app/util/s3/s3-upload");
var SignalActions = require("app/shared/actions/signal-actions");
var textFormatter = require("app/util/formatter/text");
var config = require("app/util/config/config");

var MultiActionStore = require("app/util/flux/multi-action-store");

function createActions(instanceKey) {

  var entitySuggestionsActions = EntitySuggestionsActions(instanceKey);
  var scheduleActions = ScheduleActions(instanceKey);

  var actions = Reflux.createActions({
    "toggle": {},
    "setDueDateAndOwners": {},
    "addFile": {children: ["starting","progress","completed","failed"]},
    "removeFile": {},
    "selectType": {},
    "setMetric": {},
    "removeMetric": {},
    "setText": { sync: true },
    "refresh": {},
    "selectEntity": {},
    "save": {children: ["completed","failed"]},
    "update": {children: ["completed","failed"]},
    "getActivityTypes": {children: ["completed","failed"]},
    "saveButtonPressed": {},
    "useDiscardedText": {},
    "cancelEdition": {},
    "setupEdit": { sync: true },
    "populate": { sync: true }
  });

  actions.setupEdit.preEmit = function setupEditPreEmit(activity){
    var scheduleActions = ScheduleActions(instanceKey);
    var scheduleStore = ScheduleStore(instanceKey);
    var userSelectBoxActions = UserSelectBoxActions(instanceKey);
    var userSelectBoxStore = UserSelectBoxStore(instanceKey);

    var assignedUsers = _.each(activity.assigned_users, function(assignedUser){
      assignedUser.checked = true;
      if(assignedUser.avatar) {
        assignedUser.avatarURL = assignedUser.avatar["70x70"];
      }
    });

    var files = _.each(activity.documents.concat(activity.images), function(doc){
      doc.extension = doc.type;
      doc.name = doc.file_name;
      doc.progress = 100;
      doc.uploadState = "completed";
    });

    var metrics = _.filter(activity.metrics, function(metric){
      return !metric.metric_type;
    });

    var entity = activity.organization || activity.person || activity.deal;
    if(activity.organization) {
      entity.type = "organization";
    }
    else if(activity.person) {
      entity.type = "person";
    }
    else if(activity.deal) {
      entity.type = "deal";
    }

    var text = activity.text ? activity.text.replace(/<br\s?\/?>/g, "") : null;

    var userDueDate = null;
    if(activity.due_date) {
      var fullDayDueDate = (moment(activity.due_date).format("HH:mm:ss") == "23:59:59");
      if (!fullDayDueDate) {
        userDueDate = textFormatter.dateToTimezone(activity.due_date,
          activity.timezone, window.loggedUserTzId);
      } else {
        userDueDate = moment(activity.due_date);
      }
    }

    var activityInput = {
      activityId: activity.id,
      instanceKey: instanceKey,
      dueDate: userDueDate,
      entity: entity,
      createdBy: activity.created_by,
      dropbox: activity.dropbox,
      expandedActions: true,
      expandedText: true,
      text: text,
      editing: true,
      owners: assignedUsers,
      files: files,
      metrics: metrics,
      finishedDate: activity.finished_date,
      selectedTypeId: (activity.activityType)?activity.activityType.id:null
    };

    var schedule = {
      date: (userDueDate)?moment(userDueDate).format("YYYY-MM-DD"):moment().format("YYYY-MM-DD"),
      time: (userDueDate)?moment(userDueDate).format("HH:mm:ss"):"23:59:59",
      selectedUsers: assignedUsers
    };
    scheduleActions.populate(schedule);

    var userSelectBox = {
      users: assignedUsers
    };
    userSelectBoxActions.populate(userSelectBox);

    return activityInput;
  };

  actions.populate.preEmit = function populatePreEmit(props){

    var activityInputStore = ActivityInputStore(instanceKey);
    var scheduleActions = ScheduleActions(instanceKey);
    var scheduleStore = ScheduleStore(instanceKey);
    var userSelectBoxActions = UserSelectBoxActions(instanceKey);
    var userSelectBoxStore = UserSelectBoxStore(instanceKey);

    if(props.schedule) {
      scheduleActions.populate(props.schedule);
    }
    if(props.userSelectBox) {
      userSelectBoxActions.populate(props.userSelectBox);
    }
    return props.activityInput;
  };

  actions.addFile.listen(function(file){
    if(file.name) {
      this.starting(file);
      attachmentsAPI.getPostURL(getSlug(file.name, { custom: { ".": "." } }), function (data) {

        var s3Upload = new S3Upload();
        file.tempKey = data.key;
        file.tempUrl = data.url;
        s3Upload.signingUrl = data.url;
        s3Upload.uploadFile(file);
        s3Upload.onFinishS3Put = function () {
          this.completed(file);
        }.bind(this);
        s3Upload.onProgress = function (percent) {
          this.progress(file, percent);
        }.bind(this);
      }.bind(this));
    }
  });

  actions.save.listen(function(activity, isTask){

    activityAPI.post(activity, function (body, response) {
      if (response && response.ok) {

        this.completed(body, response);
        SignalActions.show({ message: "Atividade inserida com sucesso!", hideTimeout: 3000, type: "success" });
        if (isTask) {
          entitySuggestionsActions.clearSelected();
          scheduleActions.clearSelected();
        }

        mixpanelTrackActivity(body);
      } else if (response && response.forbidden) {
        var groupUrl = config.app.webURL + "/sistema/grupos";
        var errorMsg = "Você não possui privilégios para inserir um comentário ou tarefa. Contate o administrador de sua conta para lhe conceder este privilégio em <a href='" + groupUrl + "'>Grupos</a>";

        this.failed(errorMsg);
        SignalActions.show({ message: errorMsg, type: "warning" });
      } else {
        var errorMsg = "Não foi possível inserir esta atividade.";
        errorMsg += getErrorMessagesDetails(body);
        this.failed(errorMsg);
        SignalActions.show({ message: errorMsg, type: "warning" });
      }
    }.bind(this));

  });

  actions.update.listen(function(activity){
    activityAPI.put(activity, function (body, response) {
      if (response && response.ok) {
        this.completed(body, response);
        SignalActions.show({ message: "Atividade alterada com sucesso!", hideTimeout: 3000, type: "success" });
      } else {
        var errorMsg = "Não foi possível atualizar esta atividade.";
        errorMsg += getErrorMessagesDetails(body);

        this.failed(errorMsg);
        SignalActions.show({ message: errorMsg, type: "warning" });
      }
    }.bind(this));
  });

  actions.getActivityTypes.listen(function(){

    var params = { type: true };

    agendorAPI.get("/metrics", params, function (activityTypes, response) {
      if(response && response.ok){
        this.completed(activityTypes);
      } else {
        var errorMsg = "Houve um problema na requisição de métricas.";
        this.failed(errorMsg);
        SignalActions.show({ message: errorMsg, type: "warning" });
      }
    }.bind(this));
  });

  return actions;
}

function mixpanelTrackActivity(savedActivity) {
  try {
    var activityType = savedActivity.metrics[0];
    const isNote = !activityType;

    var mixpanelProps = {
      "Tipo CA": !savedActivity.due_date ? "Normal" : "Tarefa",
      "Nome tipo CA": (isNote ? "Nota" : activityType.name),
      "Local CA": "Ficha Antiga",
      "ID do cliente": window.loggedUserAccountId
    };

    if(!isNote) {
      mixpanelProps["Status da tarefa CA"] = ((savedActivity.finished_date) ? "Finalizada" : "Pendente")
    }

    if (savedActivity.due_date) {
      mixpanelIncrementSuperProperty("Tarefas agendadas", 1);
      mixpanel.people.increment("Tarefas agendadas", 1);
    }
    mixpanel.track("Comentario adicionado", mixpanelProps);

  } catch (e) {
    captureError(e);
  }
}

function getErrorMessagesDetails(body) {
  var errorMessages = "";
  if (body[0] && body[0].error) {
    if (body[0].error == "Couldn't find Metric") {
      errorMessages += "</br> Verifique se as métricas existem.";
    }
  }

  return errorMessages;
}

module.exports = MultiActionStore.factory(createActions);

var ActivityInputStore = require("app/screens/Activity/stores/activity-input-store");
var ScheduleActions = require("app/screens/Activity/actions/schedule-actions");
var ScheduleStore = require("app/screens/Activity/stores/schedule-store");
var UserSelectBoxActions = require("app/screens/Activity/actions/user-select-box-actions");
var UserSelectBoxStore = require("app/screens/Activity/stores/user-select-box-store");
var EntitySuggestionsActions = require("app/shared/actions/entity-suggestions-actions");



// WEBPACK FOOTER //
// ./app/screens/Activity/actions/activity-input-actions.js